import React, { Component } from "react";
import { SelectButton } from "primereact/selectbutton";
import { Growl } from "primereact/growl";
import { Messages } from "primereact/messages";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subMonths from "date-fns/subMonths";
import addMonths from "date-fns/addMonths";
import { Dropdown } from "primereact/dropdown";
import { AutoComplete } from "primereact/autocomplete";
import axios from "axios";
import * as appConst from "../../../Common/constants";

class Patient extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateClass: "collapse",
      gradeClass: "collapse",
      allClass: "collapse",
      gradeFilter: "",
      fromDate: "",
      toDate: "",
      type: "",
      status: "",
      grades: [
        { label: "Grade A", value: "Grade A" },
        { label: "Grade B", value: "Grade B" },
        { label: "Grade C", value: "Grade C" },
        { label: "Grade D", value: "Grade D" }
      ],
      pno: "",
      name: "",
      nameSuggestions: null,
      nameList: [],
      homeCareFromDate: "",
      homeCareToDate: "",
      homeCareTypeFilter: ""
    };
  }

  componentDidMount() {

    if (this.props.reportType === "Next OP") {
      this.setState({
        listFilterClass: "collapse",
        detailsFilterClass: "collapse",
        homeCareFilterClass: "collapse",
        countClass: "collapse",
        nextOPFilterClass: "row p-1 border"
      });
    } else if (this.props.reportType === "Details") {
      this.LoadNames();
      this.setState({
        listFilterClass: "collapse",
        detailsFilterClass: "row p-1 border",
        homeCareFilterClass: "collapse",
        countClass: "collapse",
        nextOPFilterClass: "collapse"
      });
    }
    else if (this.props.reportType === "Home Care") {
      this.LoadNames();
      this.setState({
        listFilterClass: "collapse",
        detailsFilterClass: "collapse",
        homeCareFilterClass: "",
        countClass: "collapse",
        nextOPFilterClass: "collapse"
      });
    }
    else if (this.props.reportType === "Count") {
      this.setState({
        listFilterClass: "collapse",
        detailsFilterClass: "collapse",
        homeCareFilterClass: "collapse",
        countClass: "row p-1 border",
        nextOPFilterClass: "collapse"
      });
    }
  }

  LoadNames() {
    let _nameList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/patient/getReportNames"
      )
      .then((response) => {
        this.setState({ patientList: response.data });
        let nameData = response.data;
        nameData.forEach(function (item) {
          _nameList.push("[" + item.pno + "] " + item.name);
        });
        this.setState({ nameList: _nameList });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  suggestName(event) {
    let results = this.state.nameList.filter((t) => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });
    this.setState({ nameSuggestions: results });
  }

  render() {
    const FILTER = [
      { label: "Status", value: "Status" },
      { label: "Date", value: "Date" },
      { label: "Grade", value: "Grade" }
    ];

    const PatStatus = [
      { label: "All", value: "All" },
      { label: "Active", value: "Active" },
      { label: "Expired", value: "Expired" },
      { label: "Temp", value: "Temp" },
      { label: "Dropout", value: "Dropout" }
    ];

    const HomeCareType = [
      { label: "All", value: "All" },
      { label: "Doctor", value: "Doctor" },
      { label: "Emergency", value: "Emergency" },
      { label: "Nurse", value: "Nurse" },
      { label: "Volunteer", value: "Volunteer" }
    ];

    return (
      <div>
        <h3 align="center">Patient {this.props.reportType}</h3>
        <div >
          <div className="container-fluid" />
          <div className={this.state.listFilterClass}>
            <div className="col col-md-2">Report Type</div>
            <div className="col col-md-4">
              <SelectButton
                value={this.state.type}
                options={FILTER}
                onChange={this.onTypeChange}
                className="p-error"
              />
            </div>
          </div>
          <div className={this.state.nextOPFilterClass}>
            <div className="col col-md-2">Select Date</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.fromDate}
                onChange={e => this.setState({ fromDate: e })}
                dateFormatCalendar={"MMM yyyy"}
                minDate={new Date()}
                maxDate={addMonths(new Date(), 3)}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
                width="300px"
              />
            </div>
            {/* <div className="col col-md-2">Select To Date</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.toDate}
                onChange={e => this.setState({ toDate: e })}
                dateFormatCalendar={"MMM yyyy"}
                minDate={subMonths(new Date(), 12)}
                maxDate={new Date()}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
                width="300px"
              />
            </div> */}
          </div>
          <div className={this.state.gradeClass}>
            <div className="col col-md-2">Select Grade</div>
            <div className="col col-md-3">
              <Dropdown
                value={this.state.gradeFilter}
                options={this.state.grades}
                placeholder="Select Grade"
                onChange={e => this.setState({ gradeFilter: e.target.value })}
              />
            </div>
          </div>
          <div className={this.state.countClass}>
            <div className="col col-md-2">Select Month</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.fromDate}
                onChange={e => {
                  this.setState({ fromDate: e });
                }}
                dateFormat="MMM-yyyy"
                showMonthYearPicker
              />
            </div>
          </div>
          <div className={this.state.allClass}>
            <div className="col col-md-2">Status</div>
            <div className="col col-md-8">
              <Dropdown
                value={this.state.status}
                options={PatStatus}
                placeholder="Select Status"
                onChange={e => this.setState({ status: e.target.value })}
              />
            </div>
          </div>

          <div className={this.state.detailsFilterClass}>
            <div className="col col-md-2">Patient</div>
            <div className="col col-md-4">
              <AutoComplete
                value={this.state.name}
                onChange={this.onNameChange}
                suggestions={this.state.nameSuggestions}
                completeMethod={this.suggestName.bind(this)}
                onSelect={this.onNameSelect}
                size={34}
                className="p-error"
              />

            </div>
          </div>

          <div className={this.state.homeCareFilterClass}>
            <div className="row p-1 border">
              <div className="col col-md-2">From Date</div>
              <div className="col col-md-3">
                <DatePicker
                  selected={this.state.homeCareFromDate}
                  onChange={e => this.setState({ homeCareFromDate: e })}
                  dateFormatCalendar={"MMM yyyy"}
                  minDate={subMonths(new Date(), 12)}
                  maxDate={new Date()}
                  showMonthYearDropdown
                  dateFormat="dd-MMM-yyyy"
                  width="300px"
                />
              </div>
              <div className="col col-md-2">To Date</div>
              <div className="col col-md-3">
                <DatePicker
                  selected={this.state.homeCareToDate}
                  onChange={e => this.setState({ homeCareToDate: e })}
                  dateFormatCalendar={"MMM yyyy"}
                  minDate={subMonths(new Date(), 12)}
                  maxDate={new Date()}
                  showMonthYearDropdown
                  dateFormat="dd-MMM-yyyy"
                  width="300px"
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Type</div>
              <div className="col col-md-3">
                <Dropdown
                  value={this.state.homeCareTypeFilter}
                  options={HomeCareType}
                  placeholder="Select Type"
                  onChange={e => this.setState({ homeCareTypeFilter: e.target.value })}
                />
              </div>
            </div>
          </div>

          <div className="row p-1 border">
            <button
              onClick={this.onGenerateClick}
              className="btn btn-primary btn-md mr-2"
            >
              Generate Report
            </button>
          </div>
          <Messages ref={el => (this.messages = el)} />
          <Growl ref={el => (this.growl = el)} />
        </div>
      </div >
    );
  }

  onNameSelect = (e) => {

    let p = e.value.split("] ");
    let pno = p[0].replace("[", "");
    //let pname = p[1];

    this.setState({
      pno: pno
      // name: pname
    });
  };

  onNameChange = (e) => {
    this.setState({
      name: e.value
    });
  };

  onGenerateClick = e => {
    e.preventDefault();
    if (this.props.reportType === "Next OP") {
      if (this.state.fromDate === "") {
        this.messages.show({
          severity: "error",
          summary: "Error !!",
          detail: "Select Date !!"
        });
      } else {
        const obj = {
          reportType: this.state.reportType,
          fromDate: this.state.fromDate,
          type: "NextOP"
        };
        this.props.onClick(this.props.reportType, obj);
      }
    }
    else if (this.props.reportType === "Count") {
      if (this.state.fromDate === "") {
        this.messages.show({
          severity: "error",
          summary: "Error !!",
          detail: "Select Date !!"
        });
      } else {
        const obj = {
          reportType: this.state.reportType,
          fromDate: this.state.fromDate,
          toDate: new Date(
            this.state.fromDate.getFullYear(),
            this.state.fromDate.getMonth() + 1,
            0
          )
        };
        this.props.onClick(this.props.reportType, obj);
      }
    }
  };

  // onGenerateClick = e => {
  //   e.preventDefault();
  //   if (this.props.reportType === "Next OP") {
  //     if (this.state.type === "Date") {
  //       if (this.state.fromDate === "" || this.state.toDate === "") {
  //         this.messages.show({
  //           severity: "error",
  //           summary: "Error !!",
  //           detail: "Select Date !!"
  //         });
  //       } else {
  //         const obj = {
  //           type: this.state.type,
  //           fromDate: this.state.fromDate,
  //           toDate: this.state.toDate
  //         };
  //         this.props.onClick(this.props.reportType, obj);
  //       }
  //     } else if (this.state.type === "Grade") {
  //       if (this.state.gradeFilter === "") {
  //         this.messages.show({
  //           severity: "error",
  //           summary: "Error !!",
  //           detail: "Select Grade !!"
  //         });
  //       } else {
  //         const obj = {
  //           type: this.state.type,
  //           gradeFilter: this.state.gradeFilter
  //         };

  //         this.props.onClick(this.props.reportType, obj);
  //       }
  //     } else if (this.state.type === "Status") {
  //       if (this.state.status === "") {
  //         this.messages.show({
  //           severity: "error",
  //           summary: "Error !!",
  //           detail: "Select Status !!"
  //         });
  //       } else {
  //         const obj = {
  //           type: this.state.type,
  //           patStatus: this.state.status
  //         };

  //         this.props.onClick(this.props.reportType, obj);
  //       }
  //     } else {
  //       this.messages.show({
  //         severity: "error",
  //         summary: "Error !!",
  //         detail: "Select Report Type"
  //       });
  //     }
  //   }
  //   else if (this.props.reportType === "Details") {
  //     if (this.state.pno === "") {
  //       this.messages.show({
  //         severity: "error",
  //         summary: "Error !!",
  //         detail: "Select Patient !!"
  //       });
  //     } else {
  //       const obj = {
  //         pno: this.state.pno
  //       };
  //       this.props.onClick(this.props.reportType, obj);
  //     }
  //   }
  //   else if (this.props.reportType === "Home Care") {
  //     if (this.state.homeCareFromDate === "" || this.state.homeCareToDate === "") {
  //       this.messages.show({
  //         severity: "error",
  //         summary: "Error !!",
  //         detail: "Select Date !!"
  //       });
  //     } else {
  //       const obj = {
  //         fromDate: this.state.homeCareFromDate,
  //         toDate: this.state.homeCareToDate,
  //         type: this.state.homeCareTypeFilter
  //       };
  //       this.props.onClick(this.props.reportType, obj);
  //     }
  //   }

  // };

  onAllFilterChange = e => {
    this.setState({ allFilter: e.value });
  };

  onTypeChange = e => {
    this.setState({ type: e.value });

    switch (e.value) {
      case "Date":
        this.setState({
          dateClass: "row p-1 border",
          gradeClass: "collapse",
          allClass: "collapse"
        });
        break;
      case "Grade":
        this.setState({
          dateClass: "collapse",
          gradeClass: "row p-1 border",
          allClass: "collapse"
        });
        break;
      case "Status":
        this.setState({
          dateClass: "collapse",
          gradeClass: "collapse",
          allClass: "row p-1 border"
        });
        break;
      default:
        this.setState({
          dateClass: "collapse",
          gradeClass: "collapse",
          allClass: "collapse"
        });
    }
  };
}

export default Patient;
